import React, { useEffect, useState } from 'react';
import { Editor, Toolbar } from '@wangeditor/editor-for-react';
import { IDomEditor, IEditorConfig, IToolbarConfig } from '@wangeditor/editor';
import '@wangeditor/editor/dist/css/style.css';
import { useUploadUrl } from '@/components/CustomUpload/api';
import axios from 'axios'; // 引入 css

interface IProp {
  value?: string;
  onChange?: (value: string) => void;
  height?: number;
  name?: string;
}

type InsertFnType = (url: string, alt: string, href: string) => void;

export const WangEditor = ({ value, onChange, name = 'editor' }: IProp) => {
  const { refetch } = useUploadUrl(name);
  // editor 实例
  const [editor, setEditor] = useState<IDomEditor | null>(null); // TS 语法

  // 编辑器内容
  const [html, setHtml] = useState(value || '');

  // 工具栏配置
  const toolbarConfig: Partial<IToolbarConfig> = {
    excludeKeys: ['group-video'],
  }; // TS 语法

  // 编辑器配置
  const editorConfig: Partial<IEditorConfig> = {
    // TS 语法
    placeholder: '请输入内容...',
    MENU_CONF: {
      uploadImage: {
        customUpload: async (file: File, insertFn: InsertFnType) => {
          const data = await refetch();
          if (data.data) {
            await axios.put(data.data.upload_url, file, {
              headers: {
                'Content-Type': 'image/jpeg',
              },
            });
            insertFn(data.data.file_url, 'image', '');
          }
        },
      },
    },
  };

  // 及时销毁 editor ，重要！
  useEffect(() => {
    // if (editor) {
    //   const toolbar = DomEditor.getToolbar(editor)
    //   const curToolbarConfig = toolbar.getConfig()
    //   console.log(curToolbarConfig.toolbarKeys) // 当前菜单排序和分组
    // }
    return () => {
      if (editor == null) return;
      editor.destroy();
      setEditor(null);
    };
  }, [editor]);

  return (
    <>
      <div style={{ border: '1px solid #ccc', zIndex: 100 }}>
        <Toolbar
          editor={editor}
          defaultConfig={toolbarConfig}
          mode="default"
          style={{ borderBottom: '1px solid #ccc' }}
        />
        <Editor
          defaultConfig={editorConfig}
          value={html}
          onCreated={setEditor}
          onChange={(editor) => {
            if (onChange) {
              onChange(editor.getHtml());
            }
            setHtml(editor.getHtml());
          }}
          mode="default"
          style={{ height: '200px', overflowY: 'hidden' }}
        />
      </div>
    </>
  );
};
